import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import TeamIcon from '@/components/linear/team-icon';
import { teamPath } from '@/lib/linear-paths';
import { resolveTeams } from '@/lib/linear-utils';
import type { SharedPageProps } from '@/types/shared';
import type { Team } from '@/types/team';
import { Link, usePage } from '@inertiajs/react';

interface Props {
  teams?: Team[];
}

export default function Index({ teams }: Props) {
  const { teams: sharedTeams, currentCompany } = usePage<SharedPageProps>().props;
  const list = resolveTeams(teams ?? sharedTeams, currentCompany);

  return (
    <div className="ln-page">
      <PageToolbar title="Teams" showNew={false} />
      <div className="ln-page-scroll" style={{ padding: 16 }}>
        {list.length === 0 ? (
          <EmptyState description="No teams yet." />
        ) : (
          list.map((team) => (
            <Link key={team.id} href={teamPath(team.id)} className="ln-settings-row">
              <TeamIcon color={team.color} size={20} />
              <div>
                <div style={{ fontWeight: 510 }}>{team.name}</div>
                <div className="ln-inbox-sub">{team.key}</div>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
